const components = {
  // SDoc
  rmDocTip: '이 파일을 삭제하시겠습니까? 삭제하면 복구할 수 없습니다.',
  searchPlaceholder: '파일 또는 폴더 검색',
  upload: '업로드',
  newFolder: '새 폴더',
  folderNamePlaceholder: '폴더 이름을 입력하세요',
  cannotMoveToChild: '하위 폴더로 이동할 수 없습니다',
  moveSuccess: '이동 성공',
  moveFail: '이동 실패',
  moveToParent: '상위 폴더로 이동',
  move: '이동',
  moveTitle: '이동',
  moving: '이동 중: {{name}}',
  currentLocation: '현재 위치',
  rootDirectory: '루트',
  noFolders: '폴더 없음',
  moveToHere: '여기로 이동',
  cancel: '취소',

  // Dict
  plDictName: "이름을 입력하세요",
  plDictDesc: "설명을 입력하세요",
  dictName: '이름',
  dictDesc: '설명',

  // Selector
  plCountry: "국가/지역을 선택해주세요",
  plCreditLevel: "신용 수준을 선택하십시오",
  plCurrency: "통화를 선택해주세요",
  plProduct: "제품을 선택해주세요",

  //详情弹窗
  plContent: '내용을 입력해주세요',
  send: '보내기',
  reply: '답글',
  replyTo: '{{name}}에게 답글',
  cancelReply: '답글 취소',
  replyCount: '{{name}}개 답글',
  collapseReplies: '답글 접기',
  cameraUpload: "사진 찍어 업로드",
  takePhoto: "사진 찍기",
  switchCamera: "카메라 전환",
};

export default components;
